import apiRequest from "shared/network/apiRequest";
import Resources from "shared/actions/resourcesActions";
import Resource from "shared/actions/resourceActions";
import { BaseSubLineItemResource } from "shared/actions/roomBookActions";
import { isEmpty } from "lodash";

export function buyerSelectionToResourceValues(buyerSelections) {
  const values = {};
  Object.entries(buyerSelections).forEach(([key, productIdOrObject]) => {
    if (productIdOrObject === "_destroy") {
      values[key] = "_destroy";
    } else if (
      productIdOrObject.quantity !== undefined ||
      productIdOrObject.product_id !== undefined
    ) {
      values[key] = productIdOrObject;
    } else {
      values[key] = { product_id: productIdOrObject };
    }
  });
  return values;
}
export class RoomBooksResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "unit", `/bp/api/v1/room_books`);
  }
}

export class ProductLineResource extends Resource {
  constructor(dispatch, unitId) {
    super(dispatch, "unit", `/bp/api/v1/units/${unitId}/product_line`);
  }

  select(productLine) {
    const payload = {
      product_line: {
        tag: productLine
      }
    };
    return apiRequest
      .patch(this.url, this.dispatch, payload)
      .then(this.propagateUpdate.bind(this));
  }
}

export class SubLineItemResource extends BaseSubLineItemResource {
  constructor(dispatch, unitId) {
    super(dispatch, "line_item", `/bp/api/v1/units/${unitId}`);

    this.refreshPageContentAfterCommit = true;
  }

  selectProduct(lineItemId, product) {
    return this.selectProducts({ [lineItemId]: product.id });
  }

  selectProducts(buyerSelections) {
    const values = buyerSelectionToResourceValues(buyerSelections);

    return this.selectProductsAndQuantities(values);
  }

  deselectProducts(lineItemIds) {
    return this.selectProducts(
      lineItemIds.reduce((a, id) => {
        return { ...a, [id]: "_destroy" };
      }, {})
    );
  }

  deselectProduct(lineItemId) {
    return this.deselectProducts([lineItemId]);
  }

  selectProductsAndQuantities = buyer_selections => {
    if (isEmpty(buyer_selections)) {
      return Promise.resolve();
    }
    const url = `${this.url}/buyer_selections`;
    const payload = {
      buyer_selections
    };
    return apiRequest
      .patch(url, this.dispatch, payload)
      .then(this.propagateUpdate.bind(this));
  };
}
